import { AI_SUMMARY_FEEDBACK_COMPONENT, CLIENT_METRIC_NAME, TAG_KEY } from '../conventions';
import { incrementClientMetric } from './increment-client-metric';

function recordClientAiSummaryFeedback(
  name:
    | typeof CLIENT_METRIC_NAME.AI_SUMMARY_THUMBS_UP
    | typeof CLIENT_METRIC_NAME.AI_SUMMARY_THUMBS_DOWN,
): void {
  incrementClientMetric({
    name,
    tags: { [TAG_KEY.COMPONENT]: AI_SUMMARY_FEEDBACK_COMPONENT },
  });
}

export function recordClientAiSummaryThumbsUp(): void {
  recordClientAiSummaryFeedback(CLIENT_METRIC_NAME.AI_SUMMARY_THUMBS_UP);
}

export function recordClientAiSummaryThumbsDown(): void {
  recordClientAiSummaryFeedback(CLIENT_METRIC_NAME.AI_SUMMARY_THUMBS_DOWN);
}
